module.exports = __webpack_public_path__ + "static/media/Block.531e479e.png";